import React, { useEffect } from "react"
import { Input } from "src/components/ui/input"
import { Label } from "src/components/ui/label"
import { RefreshCw } from "lucide-react"
import { Button } from "src/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select"

const genCode = (partnerName) => {
  const prefix = (partnerName || "CP").replace(/[^A-Za-z]/g, "").slice(0, 3).toUpperCase() || "CP"
  return `${prefix}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`
}

export function ChannelPartnerBasicsTab({ form, setForm, partner }) {
  const isEdit = Boolean(partner?.id)
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  // Auto-generate referral code on name input if it is a new partner and referral code is blank
  useEffect(() => {
    if (!isEdit && form.name && !form.referral_code) {
      setForm((f) => ({ ...f, referral_code: genCode(form.name) }))
    }
  }, [form.name, isEdit])

  return (
    <div className="space-y-4">
      <Field label="Partner name">
        <Input value={form.name || ""} onChange={set("name")} placeholder="Acme Realty" autoFocus />
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Company">
          <Input value={form.company_name || ""} onChange={set("company_name")} />
        </Field>
        <Field label="RERA number">
          <Input value={form.rera_number || ""} onChange={set("rera_number")} />
        </Field>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Email">
          <Input type="email" value={form.email || ""} onChange={set("email")} placeholder="broker@firm.com" />
        </Field>
        <Field label="Phone">
          <Input value={form.phone || ""} onChange={set("phone")} placeholder="9876543210" />
        </Field>
      </div>
      <div className="space-y-1.5">
        <Label>Referral code</Label>
        <div className="flex gap-2">
          <Input
            className="font-mono"
            value={form.referral_code || ""}
            onChange={(e) => setForm((f) => ({ ...f, referral_code: e.target.value.toUpperCase() }))}
            placeholder="ACME-Z3F2"
          />
          <Button
            type="button"
            variant="outline"
            size="icon"
            title="Regenerate"
            onClick={() => setForm((f) => ({ ...f, referral_code: genCode(form.name) }))}
          >
            <RefreshCw className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Commission type">
          <Select value={form.commission_type || "percent"} onValueChange={(v) => setForm((f) => ({ ...f, commission_type: v }))}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="percent">% of agreement value</SelectItem>
              <SelectItem value="flat">Flat amount</SelectItem>
            </SelectContent>
          </Select>
        </Field>
        <Field label={form.commission_type === "flat" ? "Amount (₹)" : "Rate (%)"}>
          <Input
            type="number"
            step="0.01"
            value={form.commission_value || ""}
            onChange={set("commission_value")}
            placeholder={form.commission_type === "flat" ? "50000" : "2"}
          />
        </Field>
      </div>
      <Field label="Status">
        <Select value={form.status || "active"} onValueChange={(v) => setForm((f) => ({ ...f, status: v }))}>
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Active</SelectItem>
            <SelectItem value="inactive">Inactive</SelectItem>
            <SelectItem value="blocked">Blocked</SelectItem>
          </SelectContent>
        </Select>
      </Field>
    </div>
  )
}

function Field({ label, children }) {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      {children}
    </div>
  )
}
